module.exports = __webpack_public_path__ + "static/media/Right_Arrow_New.06c35e25.svg";